import React from 'react';
import Skeleton from './Skeleton';

const SkeletonDashboard = ({ className = '', ...props }) => {
  return (
    <div className={`skeleton-dashboard ${className}`} {...props}>
      {/* Welcome Section */}
      <div className="skeleton-dashboard-card">
        <div className="skeleton-dashboard-header">
          <Skeleton variant="text" className="title" width="50%" />
          <Skeleton variant="button" />
        </div>
        <Skeleton variant="text" width="80%" />
        <Skeleton variant="text" width="60%" />
      </div>

      {/* Quick Stats Grid */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: '1rem',
          marginBottom: '1rem'
        }}
      >
        {Array.from({ length: 4 }).map((_, index) => (
          <div key={index} className="skeleton-card">
            <Skeleton variant="text" className="subtitle" width="60%" />
            <Skeleton variant="text" className="title" width="40%" />
            <Skeleton variant="text" width="30%" />
          </div>
        ))}
      </div>

      {/* Charts Section */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '1rem',
          marginBottom: '1rem'
        }}
      >
        <div className="skeleton-dashboard-card">
          <div className="skeleton-dashboard-header">
            <Skeleton variant="text" className="title" width="40%" />
          </div>
          <Skeleton variant="text" className="skeleton-dashboard-chart" />
        </div>
        <div className="skeleton-dashboard-card">
          <div className="skeleton-dashboard-header">
            <Skeleton variant="text" className="title" width="35%" />
          </div>
          <Skeleton variant="text" className="skeleton-dashboard-chart" />
        </div>
      </div>

      {/* Recent Activity */}
      <div className="skeleton-dashboard-card">
        <div className="skeleton-dashboard-header">
          <Skeleton variant="text" className="title" width="30%" />
          <Skeleton variant="button" />
        </div>
        <div className="skeleton-dashboard-content">
          {Array.from({ length: 5 }).map((_, index) => (
            <div
              key={index}
              style={{ display: 'flex', alignItems: 'center', marginBottom: '1rem' }}
            >
              <Skeleton variant="avatar" className="small" style={{ marginRight: '1rem' }} />
              <div style={{ flex: 1 }}>
                <Skeleton variant="text" width="70%" />
                <Skeleton variant="text" width="50%" />
              </div>
              <Skeleton variant="text" width="15%" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SkeletonDashboard;
